// authFailure.js — POR QUÉ FALLÓ un intento de autenticación (F6.7b, 2ª pasada).
//
// El problema que cierra (smoke on-device 2026-07-28): tras cerrar sesión,
// iniciar sesión falló "sin razón" — el mensaje no distinguía nada. El código
// de LoginPage tenía UNA sola salida para todo lo que no fuera un detalle
// estructurado del backend: `login_failed_fallback` ("No se pudo iniciar
// sesión"). Con eso, sin red, con la contraseña mal y con el backend caído el
// usuario lee exactamente lo mismo — y no puede hacer nada distinto en cada
// caso, que es justo para lo que sirve un mensaje.
//
// Función pura, sin imports: clasifica el error de axios en los tres cubos que
// le importan a una persona frente al formulario. Deliberadamente NO decide el
// texto: cada pantalla elige su llave i18n (entrar y registrarse no dicen lo
// mismo), y los detalles ESPECÍFICOS del backend (bloqueo por intentos, cuenta
// de Google, verificación pendiente) siguen ganando en su pantalla — este
// clasificador solo cubre lo que antes caía al mensaje mudo.
//
// La regla de "sin conexión" es la misma que api.js usa para su forma-de-red y
// por el mismo motivo: sin `response` no hubo servidor del otro lado — red
// caída, DNS frío, techo de espera agotado o petición cancelada. Ninguna de
// esas es culpa de las credenciales, y ninguna debe sugerirlo.

export const AUTH_FAILURE = {
  OFFLINE: 'offline',          // no hubo respuesta: red/timeout/cancelación
  CREDENTIALS: 'credentials',  // el servidor contestó "no" a esta identidad
  SERVER: 'server',            // el servidor está mal (5xx)
  OTHER: 'other',              // 4xx con significado propio: lo dice el backend
};

/**
 * @param {any} err  El error tal como lo lanza axios.
 * @returns {'offline'|'credentials'|'server'|'other'}
 */
export function classifyAuthFailure(err) {
  const status = err && err.response ? err.response.status : undefined;
  if (status === undefined) return AUTH_FAILURE.OFFLINE;
  if (status >= 500) return AUTH_FAILURE.SERVER;
  if (status === 401) return AUTH_FAILURE.CREDENTIALS;
  return AUTH_FAILURE.OTHER;
}

export default classifyAuthFailure;
